import { IBitwisePayload } from '../BitwiseGroup';

export function bitwisePayloadDisabler(bitwisePayloads: IBitwisePayload[], ...values: number[]): IBitwisePayload[] {
  return bitwisePayloads.map((payload) => ({
    ...payload,
    enabled: !values.some((value) => value === payload.value),
  }));
}

export function bitwisePayloadMasker(bitwisePayloads: IBitwisePayload[], disabledMask: number) {
  return bitwisePayloads.map((payload) => ({
    ...payload,
    enabled: (payload.value & disabledMask) !== payload.value,
  }));
}
